import CoursesPage, { CoursesPageProps } from './CoursesPage';

export type { CoursesPageProps };
export default CoursesPage;
